export default "__VITE_ASSET__lNgqyosD__"